import bootstrapBreakpoints from '../grid';
import Base from '../../js/_base';

let $window, $document;

export default class Truncate extends Base {
    get classList() {
        return {
            hide: 'd-none',
            truncated: 'truncated',
            authorsButton: 'btn-authors-truncate',
        };
    }

    get selectors() {
        return {
            between: '.authors-truncate-to-hide',
            toggleTruncate: '.authors-toggle',
            authorsButton: '.btn-authors-truncate',
            truncateButtons: '.btn-authors-truncate, .authors-truncate-to-hide',
            listItems: 'li:not(.authors-toggle):not(.authors-truncate-to-hide)',
        };
    }

    constructor(allAuthorsLists, windowEl, documentEl) {
        super();
        $window = windowEl || $(window);
        $document = documentEl || $(document);
        this.allAuthorsLists = allAuthorsLists;
        this._inBetweenItemHTML = this.inBetweenItemHTML;
        this.initialize();
    }

    get buttonText() {
        const more = this.currentAuthorsList.dataset.truncateMoreLabel || 'authors';
        return `+${this.hiddenItems} ${more}`;
    }

    get truncatedButtonText() {
        return this.currentAuthorsList.dataset.truncateLessLabel || 'fewer';
    }

    get button() {
        return `
    <li class="list-inline-item authors-toggle  ">
        <button class="truncated btn btn-xs btn-outline-secondary btn-authors-truncate ml-1" >${this.buttonText}</button>
    </li>`;
    }

    get inBetweenItemHTML() {
        return '<li class="list-inline-item authors-truncate-to-hide "><a href="#" role="button" class="toggle truncation ml-1 d-inline-block">[...]</a></li>';
    }

    get toggleButton() {
        return this.currentAuthorsList.querySelector(this._selectors.authorsButton);
    }

    get inBetweenItem() {
        return this.currentAuthorsList.querySelector(this._selectors.between);
    }

    get listItems() {
        return this.convertToArray(this.currentAuthorsList.querySelectorAll(this._selectors.listItems));
    }

    get showMiddleDots() {
        return !!this.currentAuthorsList.dataset.truncateDots;
    }

    get viewport() {
        const lg = this.currentAuthorsList.dataset.visibleItems;
        const md = this.currentAuthorsList.dataset.visibleItemsMd;
        const sm = this.currentAuthorsList.dataset.visibleItemsSm;
        return {lg, md, sm};
    }

    get maxLength() {
        const {lg, sm, md} = this.viewport;
        let maxItems = sm || md || lg;
        const width = $window.width();
        if (width > bootstrapBreakpoints.lg) {
            maxItems = lg;
        } else if (width > bootstrapBreakpoints.md) {
            maxItems = md || lg;
        } else if (width > bootstrapBreakpoints.sm) {
            maxItems = sm || md || lg;
        }
        return maxItems - 1;
    }

    async initialize() {
        super.initialize();
        this.allAuthorsLists.forEach(item => {
            this.currentAuthorsList = item;
            const lastAuthorsList = this.truncate(item);
            lastAuthorsList?.insertAdjacentHTML('afterend', this.button);
            const buttons = this.convertToArray(item.querySelectorAll(this._selectors.truncateButtons));
            buttons.forEach(button => {
                if (!this.hiddenItems) {
                    button.classList.add(this._classList.hide);
                }
                this.addEventListeners(button);
            });
        });
    }

    addEventListeners(button) {
        super.addEventListeners();
        button.addEventListener('click', this.onClick.bind(this, this.currentAuthorsList));
        if (button.classList.contains(this._classList.authorsButton)) {
            this.onViewPortChange(button, this.currentAuthorsList);
        }
    }

    truncate() {
        const thisAuthorsList = this.currentAuthorsList;
        const items = this.listItems;
        const maxItems = this.maxLength;
        let lastIndex = items.length - 1;
        const last = items[lastIndex];
        let toHide = this.inBetweenItem;
        let showDots = !!this.showMiddleDots;
        lastIndex = showDots ? lastIndex : lastIndex + 1;
        this.hiddenItems = 0;

        items.forEach((item, index) => {
            if (index > maxItems && index !== lastIndex) {
                item.classList.add(this._classList.hide);
                this.hiddenItems++;
            } else {
                item.classList.remove(this._classList.hide);
            }
        });

        if (showDots && !toHide) {
            last?.insertAdjacentHTML('beforebegin', this._inBetweenItemHTML);

            if (!this.hiddenItems && items.length > 0) {
                thisAuthorsList.querySelector(this._selectors.between).classList.add(this._classList.hide);
            }
        }

        return last;
    }

    onClick(authorsList, e) {
        e.preventDefault();
        this.currentAuthorsList = authorsList;
        const button = this.toggleButton;
        const between = this.inBetweenItem;
        if (button) {
            if (button.classList.contains(this._classList.truncated)) {
                this.convertToArray(authorsList.querySelectorAll(this._selectors.listItems)).forEach(item => {
                    item.classList.remove(this._classList.hide);
                });
                button.textContent = this.truncatedButtonText;
            } else {
                this.truncate(authorsList);
                button.textContent = this.buttonText;
            }
            button.classList.toggle(this._classList.truncated);
        }
        if (between) {
            between.classList.toggle(this._classList.hide);
        }
    }

    onViewPortChange(button, author) {
        const viewPort = this.viewport;
        for (let key in viewPort) {
            if (viewPort[key]) {
                $document
                    .on('screen-' + key + '-on', this.onViewPortTruncate.bind(this, button, author))
                    .on('screen-' + key + '-off', this.onViewPortTruncate.bind(this, button, author));
            }
        }
    }

    onViewPortTruncate(button, authorsList) {
        if (button.classList.contains(this._classList.truncated)) {
            this.currentAuthorsList = authorsList;
            this.truncate();
            button.textContent = this.buttonText;
        }
        this.toggleButtonVisibility(button);
    }

    toggleButtonVisibility(button) {
        if (this.hiddenItems) {
            button.classList.remove(this._classList.hide);
        } else {
            button.classList.add(this._classList.hide);
        }
    }
}
